/**
 * Stats Block — count-up animation triggered on scroll into view.
 * Respects prefers-reduced-motion by skipping animation.
 * Handles integers and decimals; preserves original formatting.
 */

const DURATION = 1400;
const EASING = (t) => 1 - Math.pow(1 - t, 3); // ease-out cubic

const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)',
).matches;

const animateCount = (el, target, isFloat, decimals) => {
  if (prefersReducedMotion) return;

  const start = performance.now();

  const tick = (now) => {
    const elapsed = now - start;
    const progress = Math.min(elapsed / DURATION, 1);
    const value = EASING(progress) * target;

    el.textContent = isFloat
      ? value.toFixed(decimals)
      : Math.round(value).toLocaleString();

    if (progress < 1) {
      requestAnimationFrame(tick);
    } else {
      el.textContent = isFloat
        ? target.toFixed(decimals)
        : target.toLocaleString();
    }
  };

  requestAnimationFrame(tick);
};

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const grid = entry.target;
      observer.unobserve(grid);

      grid.querySelectorAll('.block-stats__count[data-count]').forEach((el) => {
        const raw = el.dataset.count;
        const isFloat = raw.includes('.');
        const decimals = isFloat ? (raw.split('.')[1] || '').length : 0;
        const target = parseFloat(raw.replace(/,/g, ''));

        if (isNaN(target)) return;

        el.textContent = '0';
        animateCount(el, target, isFloat, decimals);
      });
    });
  },
  { threshold: 0.2 },
);

document.querySelectorAll('.block-stats__grid').forEach((grid) => {
  observer.observe(grid);
});
